import React from 'react'
import { XCircleIcon } from '@heroicons/react/24/solid'
import EtCreateFollowUpUserActionComp from '@/features/userActions/EtCreateFollowUpUserActionComp'


const EtModalCreateFollowUpUserAction = ({ showModal = false, onClose = () => {}, refetchUserActions = () => {}, defaultTrailId = '', defaultSessionId = '', calendarMeetingId=null, sourcesourceConversation=null }) => {

  // Author - Atul Pandey
  // First Created - 22 Jun 2025
  // Purpose - Modal wrapper to create a follow up user action from Trinity Power up companion including capturing a new follow up action resulting from a meeting or conversation
  
  
  // Original Update Trail
  // ----------------------  
  // First Created: 06 Apr 2025  
  // Author: Atul Pandey  
  // Purpose: Modal wrapper for creating a user action from the from the landing page
  // Updated - 17 May 2025 - Added defaultTrailId = '', defaultSessionId = '' to reuse the modal for user sessions
  
    if (!showModal) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-start font-poppins overflow-y-auto p-4" style={{ zIndex: 9999 }}>
      <div className="bg-black p-3 rounded-lg shadow-lg shadow-black relative w-full max-w-5xl">
        
        {/* Close Button */}
        <div
            className="absolute top-1 right-1 m-1 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
            onClick={onClose}
        >
            <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7' />
        </div>

        {/* Create Form Component */}
        <EtCreateFollowUpUserActionComp 
          onClose={onClose} 
          refetchUserActions={refetchUserActions} 
          defaultTrailId={defaultTrailId}                       // ✅ 17 May 2025
          defaultSessionId={defaultSessionId}                   // ✅ 17 May 2025
          calendarMeetingId={calendarMeetingId}                 // ✅ 22 Jun 2025
          sourcesourceConversation={sourcesourceConversation}   // ✅ 22 Jun 2025
        />

      </div>
    </div>
  )
}

export default EtModalCreateFollowUpUserAction
